// extracted by mini-css-extract-plugin
module.exports = {"root":"_3YSyr","deemphasized":"_4eWe3"};